module.exports = __webpack_public_path__ + "static/dr.onLogo-d8276b588fb4e1713773601daed232d8.svg";